export default (feature: string, defaultValue: boolean | undefined = false) => {
  const { $posthog } = useNuxtApp()

  const isFeatureEnabled = useState(`feature-enabled:${feature}`, () => defaultValue)
  $posthog.onFeatureFlags(() => {
    isFeatureEnabled.value = !!$posthog.isFeatureEnabled(feature)
  })

  return {
    enabled: isFeatureEnabled,
  }
}
